import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import * as Actions from '../store/actions';
import DraggableSelectedLesson from './DraggableSelectedLesson';

const styles = theme => ({
});

const dayTarget = {
    drop: (props, monitor) => {
        return {
            week: props.week,
            day: props.day,
            dayValue: props.dayValue
        }
    }
}

function collect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        hovered: monitor.isOver(),
        item: monitor.getItem()
    }
}

class DayTarget extends Component {

    // constructor(props) {
    //     super(props);
    // }

    checkDisplayLesson = (week, day, lessons) => {
        return lessons.map(lesson => {
            if (lesson.WeekNum === week && lesson.DayOfWeek === day) {
                return (
                    <DraggableSelectedLesson
                        key={lesson.module_id + '_' + lesson.lesson_id}
                        item={lesson}
                        onDrop={this.props.dropLessonToDay}
                        onDelete={this.props.removeModuleLessonReleation}
                        module_id={this.props.module_id}
                        toggleConfirmDragDialog={this.props.toggleConfirmDragDialog}
                    />
                )
            }
        })
    }

    render() {
        const { connectDropTarget, hovered, mappedLessons, week, day } = this.props;
        let backgroundColor = hovered ? 'rgba(100, 25, 21, .7)' : 'white';

        if (this.props.weekend) {
            backgroundColor = hovered ? 'rgba(52, 8, 29, .7)' : 'white';
        }

        return connectDropTarget(
            <div className={'courseModuleTarget'} style={{ background: backgroundColor }} key={this.props.week + '_' + this.props.day}>
                {/* <div>{this.props.week}-{this.props.day}</div> */}
                {this.checkDisplayLesson(week, day, mappedLessons)}
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        dropLessonToDay: Actions.dropLessonToDay,
        toggleConfirmDragDialog: Actions.toggleConfirmDragDialog
    }, dispatch);
}

function mapStateToProps({ lessonApp }) {
    return {

    }
}

export default DropTarget('item', dayTarget, collect)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(DayTarget))));



// WEBPACK FOOTER //
// src/main/content/course/scheduleComponents/DayTarget.js